import { render } from "./ImageToImage.vue?vue&type=template&id=5dfb04dc&scoped=true"
import script from "./ImageToImage.vue?vue&type=script&lang=js"
export * from "./ImageToImage.vue?vue&type=script&lang=js"

import "./ImageToImage.vue?vue&type=style&index=0&id=5dfb04dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfb04dc"]])

export default __exports__